import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, LayoutDashboard, Users, UserCog } from "lucide-react";

/**
 * Global Admin Control Center button + dropdown.
 * Shown in public Nav.jsx only when logged-in user is admin or dispatcher.
 * Dispatcher does NOT see "User Management".
 */
export default function AdminControlCenter({ role }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", onClick);
    document.addEventListener("keydown", onKey);
    return () => { document.removeEventListener("mousedown", onClick); document.removeEventListener("keydown", onKey); };
  }, []);

  if (role !== "admin" && role !== "dispatcher") return null;

  const items = [
    { to: "/admin", label: "Dashboard", icon: LayoutDashboard, roles: ["admin", "dispatcher"], testid: "acc-dashboard" },
    { to: "/admin/users", label: "User Management", icon: Users, roles: ["admin"], testid: "acc-users" },
    { to: "/admin/settings", label: "My Settings", icon: UserCog, roles: ["admin", "dispatcher"], testid: "acc-settings" },
  ].filter((i) => i.roles.includes(role));

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        data-testid="admin-control-center-btn"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-2 border border-[#C5A24A]/60 hover:border-[#E6C46E] px-4 py-2 text-[10px] uppercase tracking-[0.25em] transition-all"
        style={{
          fontFamily: "'Cormorant Garamond', Georgia, serif",
          fontWeight: 600,
          background: "linear-gradient(180deg, rgba(230,196,110,0.08) 0%, rgba(182,138,48,0.05) 100%)",
          color: "#E6C46E",
        }}
      >
        Admin Control Center <ChevronDown size={12} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div
          data-testid="admin-control-center-menu"
          className="absolute right-0 top-full mt-2 w-60 bg-[#0B0B0C]/95 backdrop-blur-xl border border-white/15 shadow-2xl"
        >
          {items.map((it) => {
            const Icon = it.icon;
            return (
              <Link
                key={it.to}
                to={it.to}
                onClick={() => setOpen(false)}
                data-testid={it.testid}
                className="flex items-center gap-3 px-4 py-3 text-[12px] text-[#E6E6E6] hover:bg-white/[0.06] hover:text-white border-b border-white/5 last:border-b-0 tracking-wide"
              >
                <Icon size={14} strokeWidth={1.5} className="text-[#C5A24A]" />
                {it.label}
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
